module.exports = __webpack_public_path__ + "static/img/102413.14fcb121.png";